import { createReducer, on } from '@ngrx/store';
import { defaultPermissionListFilter } from '../types/permission-list-filter';
import {
  fetchPermissionList,
  loadedPermissionList,
  failedPermissionList,
  updatePermissionListFilter,
  resetPermissionList,
  deletePermission,
} from './permission-list.actions';
import {
  initialPermissionListState,
  PermissionListState,
  initialDataSource,
} from './permission-list.state';
import { PermissionListInterface } from '../types/permission-list';

export const permissionListReducer = createReducer(
  initialPermissionListState,
  on(fetchPermissionList, (state): PermissionListState => ({ ...state })),
  on(loadedPermissionList, (state, action): PermissionListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedPermissionList, (state): PermissionListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updatePermissionListFilter, (state, { filter }): PermissionListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultPermissionListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(deletePermission, (state, action): PermissionListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (permission: PermissionListInterface) =>
            permission.permission_section_id !== action.permission_section_id
        ),
      },
    };
  }),
  on(resetPermissionList, (state): PermissionListState => {
    return {
      ...state,
      filter: { ...defaultPermissionListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
